import React from 'react';
import PropTypes from 'prop-types';
import { Box, StackView, Typography } from '@telus-uds/components-web';
import getFormattedPricing from '../orderDetailsSection/utils';
import {
  Thead,
  Td,
  Tr,
  Th
} from '../orderDetailsSection/ratePlans/components/css';
import { powerFleetFieldTypeSummary, powerFleetFieldTypeSummaryHeading } from '../../utils/constant';

const ServicesAccessory = ({ serviceData, serviceName }) => {
  if (!serviceData.length) return null;

  return (
    <table>
      <Thead>
        <Tr>
          <Th width="50%">{serviceName}</Th>
          <Th width="10%">Quantity</Th>
          <Th width="10%">Unit Price</Th>
          <Th width="10%">Total</Th>
        </Tr>
      </Thead>
      <tbody>
        {serviceData.map(data => {
          const { name, additionalQuantity, unitPrice } = data;
          return (
            <Tr>
              <Td style={{ background: '#f7f7f7', fontWeight: '700' }}>
                {name}
              </Td>
              <Td>{additionalQuantity}</Td>
              <Td>{getFormattedPricing(unitPrice)}</Td>
              <Td>{getFormattedPricing(unitPrice * additionalQuantity)}</Td>
            </Tr>
          );
        })}
      </tbody>
    </table>
  );
};

ServicesAccessory.propTypes = {
  serviceName: PropTypes.string.isRequired,
  serviceData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      device: PropTypes.string,
      term: PropTypes.string,
      quantity: PropTypes.number,
      unitPrice: PropTypes.number,
      fiftyPercentInUS: PropTypes.bool
    })
  ).isRequired
};

const SummaryHardwarePowerFleet = ({ orderData, total, itemKey }) => {

  return (
    <>
      {(total[powerFleetFieldTypeSummary[itemKey]] > 0) && (
        <StackView space={3}>
          <Typography heading="h4" variant={{ size: 'h4' }} block>{powerFleetFieldTypeSummaryHeading[itemKey]}</Typography>
          <Box>
            <ServicesAccessory
              serviceData={orderData[`${powerFleetFieldTypeSummary[itemKey]}List`]}
              serviceName={powerFleetFieldTypeSummaryHeading[itemKey]}
            />
            <div
              style={{
                background: '#f4f4f4',
                border: '1px solid #e3e3e3',
                display: 'flex',
                justifyContent: 'space-between',
                padding: '1rem'
              }}
            >
              <p style={{ marginLeft: '16rem', fontWeight: '600' }}>Total</p>
              <p style={{ marginRight: '0.65rem', fontWeight: '600' }}>
                {getFormattedPricing(total[powerFleetFieldTypeSummary[itemKey]])}
              </p>
            </div>
          </Box>
        </StackView>
      )}
    </>
  );
};

SummaryHardwarePowerFleet.propTypes = {
  orderData: PropTypes.shape({
    monthlySoftwareSubscriptionList: PropTypes.arrayOf(PropTypes.shape({})),
    hardwarePowerFleetList: PropTypes.arrayOf(PropTypes.shape({})),
    hardwareColdChainPowerFleetList: PropTypes.arrayOf(PropTypes.shape({})),
    professionalServicesColdChainList: PropTypes.arrayOf(PropTypes.shape({})),
    professionalServicesList: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  total: PropTypes.shape({
    monthlySoftwareSubscription: PropTypes.number,
    hardwarePowerFleet: PropTypes.number,
    professionalServices: PropTypes.number,
    hardwareColdChainPowerFleet: PropTypes.number,
    professionalServicesColdChain: PropTypes.number
  }).isRequired,
  itemKey: PropTypes.string.isRequired
};

export default SummaryHardwarePowerFleet;
